import React from 'react';
import { Button, LabeledInput, Row } from "@commonsku/styles";
import {oauth} from '../../utils';

const SendVerificationEmail = () => {
  const [response, setResponse] = React.useState<string>('');

  return <form action="" onSubmit={async (e) => {
    e.preventDefault();
    const formData = Object.fromEntries(new FormData(e.currentTarget).entries());
    const response = await oauth('POST', 'tech-support', {
      ...formData,
      actionName: 'send_verification_email',
    });
    setResponse(JSON.stringify(response.json ?? "", null, 2));
  }}>
    <LabeledInput
      label="Login Name"
      placeholder="Login Name"
      name="login_name"
      type="text"
      required
    />
    <Button type="submit">Send Verification Email</Button>
    <pre>{response}</pre>
  </form>;
};

SendVerificationEmail.label = `Send Verification Email`;

export default SendVerificationEmail;
